import React from "react";
import "./OthersTaskCard.scss";

const OthersTaskCard = ({task}) => {
  const isoDate = task.createdAt;
  const date = new Date(isoDate);
  const formattedDate = date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  return (
    <div className="other-card-container">
        <div className="card-left">
            <div className="task-id">{task.roNumber}</div>
            <div className="date">{formattedDate}</div>
        </div>
        <div className="card-right">
            <div className="card-status loss">Parts not available</div>
        </div>
    </div>
  );
};

export default OthersTaskCard;
